import { queryOptions } from "@tanstack/react-query";
import { listOrganizationMembers } from "api-client";

import {
  organizationKeys,
  type OrganizationMembersQueryInput,
} from "./organizations";

export function organizationMembersQueryOptions(
  organizationId: string,
  input: OrganizationMembersQueryInput,
) {
  return queryOptions({
    queryKey: organizationKeys.memberList(organizationId, input),
    async queryFn() {
      const response = await listOrganizationMembers({
        path: { organizationId },
        query: input,
      });
      return response.data.data;
    },
  });
}
